import React, { useState } from 'react';
import { call, savePreviewToken } from './api.js';
import { go } from './nav.js';

/* ═══════════════════════════════════════════════════════════════════════════
 * THE PRIVATE PREVIEW'S PASSWORD SCREEN — 17 October 2026.
 *
 * Al-Noor: the public pages stay open for Google, Meta and Apple; the Eleater
 * app sits behind one password until launch. The server (middleware/preview.js)
 * answers 423 to every call until it has the password's token, and api.js
 * opens this screen on that answer. Nothing here is drawn unless PREVIEW_PASSWORD
 * is set on eleat-api.
 *
 * Built in the sign-in screen's own shape (SignIn.jsx: .screen · .logo · .copy ·
 * .label · .tin · .err · .cta) so it carries no new look. ⚠️ THREE SENTENCES ON
 * IT ARE NEW COPY — "Eleat is in private preview.", "Enter the password you were
 * given.", "Enter" — there was no existing Eleat wording for a preview door;
 * Al-Noor's to change.
 * ═══════════════════════════════════════════════════════════════════════════ */
export default function Preview() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (busy) return;
    if (!password.trim()) { setError('Enter the password.'); return; }
    setBusy(true); setError('');
    try {
      const r = await call('/auth/preview', { method: 'POST', body: { password: password.trim() } });
      if (r && r.token) savePreviewToken(r.token);
      go('?', { replace: true });
    } catch (err) {
      setError(err.message || 'That password is not right.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="screen" onSubmit={submit} noValidate>
      <div className="logo">
        <img className="lmark" src="/eleat_mark.png" alt="" />
        <img className="lword" src="/eleat_word.png" alt="Eleat" />
      </div>
      <div className="copy">
        <h1>Eleat is in private preview.</h1>
        <p className="sub">Enter the password you were given.</p>
      </div>
      <div className="fld">
        <div className="label">Password</div>
        <input
          className="tin"
          type="password"
          autoComplete="off"
          autoCapitalize="off"
          spellCheck={false}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
        />
      </div>
      {error ? <div className="err" aria-live="polite">{error}</div> : null}
      <button className="cta" type="submit" disabled={busy}>{busy ? 'Checking…' : 'Enter'}</button>
    </form>
  );
}
